export const DEFAULT_OUTLINE_DOCUMENT_THEME = {
  rail: "var(--color-middle-purple)",
  group: "white",
  itemHover: "var(--color-light-gray)",
};

export const OUTLINE_DOCUMENT_THEMES = {
  ORANGE: {
    rail: "var(--outline-doc-theme-orange-rail)",
    group: "var(--outline-doc-theme-orange-group)",
    itemHover: "var(--outline-doc-theme-orange-item-hover)",
  },
  SKY_BLUE: {
    rail: "var(--outline-doc-theme-sky-blue-rail)",
    group: "var(--outline-doc-theme-sky-blue-group)",
    itemHover: "var(--outline-doc-theme-sky-blue-item-hover)",
  },
  TEAL: {
    rail: "var(--outline-doc-theme-teal-rail)",
    group: "var(--outline-doc-theme-teal-group)",
    itemHover: "var(--outline-doc-theme-teal-item-hover)",
  },
  MINT_GREEN: {
    rail: "var(--outline-doc-theme-mint-green-rail)",
    group: "var(--outline-doc-theme-mint-green-group)",
    itemHover: "var(--outline-doc-theme-mint-green-item-hover)",
  },
  CORAL_PINK: {
    rail: "var(--outline-doc-theme-coral-pink-rail)",
    group: "var(--outline-doc-theme-coral-pink-group)",
    itemHover: "var(--outline-doc-theme-coral-pink-item-hover)",
  },
  ROYAL_PURPLE: {
    rail: "var(--outline-doc-theme-royal-purple-rail)",
    group: "var(--outline-doc-theme-royal-purple-group)",
    itemHover: "var(--outline-doc-theme-royal-purple-item-hover)",
  },
  LIME: {
    rail: "var(--outline-doc-theme-lime-rail)",
    group: "var(--outline-doc-theme-lime-group)",
    itemHover: "var(--outline-doc-theme-lime-item-hover)",
  },
  BROWN: {
    rail: "var(--outline-doc-theme-brown-rail)",
    group: "var(--outline-doc-theme-brown-group)",
    itemHover: "var(--outline-doc-theme-brown-item-hover)",
  },
};

export const resolveDocumentTheme = (documentTheme) =>
  OUTLINE_DOCUMENT_THEMES[documentTheme] ?? DEFAULT_OUTLINE_DOCUMENT_THEME;

export default OUTLINE_DOCUMENT_THEMES;
